const version = process.env.CF_PAGES_COMMIT_SHA || "dev";
export default version;
